import { Box } from "@mui/system";

export default function SearchDate({ text }) {
  return (
    <Box
      sx={{
        color: "#6E6E6E",
        fontWeight: 400,
        fontSize: "13px",
        fontFamily: "FustatRegular",
      }}
    >
      {text}
    </Box>
  );
}
